import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/img/logo192.png";
import { withRouter } from "react-router-dom";
import DrawerBtn from "../../components/Drawer/DrawerBtn";
import jwt_decode from "jwt-decode";

import "./header.css";
import { connect } from "react-redux";

function Logo() {
  return (
    <Link
      to="/"
      style={{
        textAlign: "center",
        display: "block",
        paddingTop: 5,
        paddingBottom: 5,
      }}
    >
      <img src={logo} alt="romak" width={55} height={55} />
    </Link>
  );
}

function Header({ location, history, isAuthorize }) {
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    var token = localStorage.getItem('accessToken');
    if (token !== null) {
      var user = jwt_decode(token);
      setUserName(user.UserName)
    }
  },[])
  const logout = () => {
    var d = window.confirm("آیا مایل به خروج از نرم افزار هستید؟");

    if (d) {
      localStorage.clear();
      window.location.assign("/");
    }
  };
  return (
    <header>
      <Container fluid>
        <Row>
          <Col xs="2" md="1" style={{ textAlign: "center" }}>
            <div className="headerRow" style={{ justifyContent: 'center' }}>
              <DrawerBtn />
            </div>
          </Col>
          <Col xs="2" md="1" style={{ textAlign: "center" }}>
            <Logo />
          </Col>
          <Col xs="6" md="8">

          </Col>
          <Col xs="2" md="2">
            <div className="headerRow leftRow">
              <span style={{paddingLeft: 10}}>{userName !== null ? userName : ''}</span>
              {isAuthorize ? (
                <div onClick={logout} style={{ cursor: "pointer" }}>
                  خروج
                </div>
              ) : null}
            </div>

          </Col>
        </Row>
      </Container>
    </header>
  );
}
const MapStateToProps = (state) => {
  return {
    isAuthorize: state.handleAuth.isAuthorize
  }
};
export default connect(MapStateToProps)(withRouter(Header));
